import Vue from "vue";
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";

extend("required", required);
extend("mobilephone", value => {
	return /^05[0-578]\d{7}$/.test(value);
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
